<template>
  <v-list nav>
    <v-list-item v-for="item in items" :key="item.title" link :to="item.link">
      <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item>
    <v-divider></v-divider>
    <!-- <template v-if="isConnected">
      <v-subheader>Notarios</v-subheader>
      <v-list-item v-for="item in notarios" :key="item.title" link :to="item.link">
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </template>-->
  </v-list>
</template>

<script>
export default {
  props: ["show"],
  computed: {
    isConnected() {
      return this.$store.state.firUser != null;
    },
  },
  methods: {},
  data: () => ({
    items: [
      {
        title: "Anuncios",
        icon: "mdi-",
        link: "/",
      },
      {
        title: "Directorio",
        icon: "mdi-calendar-check-outline",
        link: "/directorio",
      },
      { title: "Leyes", icon: "mdi-account-hard-hat", link: "/leyes" },
      {
        title: "Disposiciones",
        icon: "mdi-account",
        link: "/disposiciones",
      },
      {
        title: "Consejo Directivo",
        icon: "mdi-",
        link: "/consejo",
      },
    ],
    notarios: [{ title: "AAAA", link: "/aaa" }],
  }),
};
</script>

<style>
</style>